'use client';
const isRequest = (input)=>input instanceof Request;
const isResponse = (input)=>input instanceof Response;

export { isRequest, isResponse };
//# sourceMappingURL=guards.js.map
